<script>
    /*
    	ServiceFieldsGroup1.svelte

        Service Info - 7 fields

        Expandable/Collapsible and contains a predetermined set of DataFields

        {
            additionalInformation: []
            addressLine1: "3117 Olive St"
            availability: null
            city: "Saint Louis"
            costFreeText: null
            country: null
            county: null
            coverageAreas: []
            coverageCounties: null
            coverageGranularity: null
            coveragePostalCodes: null
            createdAt: "2022-08-03T01:09:18.557349Z"
            description: "-"
            eligibility: null

            googleBusinessLink: null
            googleNumberRatings: null
            googleRating: null                  // service[GOOGLE_RATING]
            googleTestimonials: null

            id: 1588848
            insuranceAccepted: []
            lastValidated: null
            lat: 38.6332
            locationPrecision: "street"
            lon: -90.2164

            mainEmail: null
            mainFacebook: null
            mainFax: null
            mainPhone: "3146523663 ext1132"
            mainTwitter: null
            mainWebsite: "http://www.foodoutreach.org"

            minerNotes: []
            necessaryDocuments: []
            necessaryMaterials: []
            nextSteps: null
            operatingHours: null
            otherSocialMedia: null
            postalCode: "63103"
            reviewed: 1
            serviceName: "Food Outreach, Inc."
            source: "MealsOnWheels"
            state: "MO"
            supportedInsurance: null
            supportedLanguages: []
            taxonomies: {open-eligibility-2022: Array(2), tcare-taxonomy-1: Array(3)}
            updatedAt: "2022-08-03T01:09:18.557349Z"
        }

        {

            // NEW GROUPINGS

            // 1 - Service Information
            serviceName: "Food Outreach, Inc."
            description: "-"
            mainFax: null
            mainPhone: "3146523663 ext1132"
            mainEmail: null
            operatingHours: null
            coverageAreas: []
            mainWebsite: "http://www.foodoutreach.org"

            // 2 - Location Information
            addressLine1: "3117 Olive St"
            city: "Saint Louis"
            state: "MO"
            postalCode: "63103"
            county: null
            country: null

            // 3 - Additional Information
            necessaryDocuments: []
            necessaryMaterials: []
            insuranceAccepted: []
            additionalInformation: []
            nextSteps: null
            costFreeText: null
            eligibility: null
            availability: null                      // 'available','unavailable','wait_list','others'
            supportedLanguages: []
            reviewed: 1
            lastValidated: null

            // 4 - Social/Online Information
            mainFacebook: null
            mainTwitter: null
            otherSocialMedia: null
            googleBusinessLink: null
            googleRating: null
            googleNumberRatings: null

            // 5 - Coverage
            coverageCounties: null
            coveragePostalCodes: null
            coverageGranularity: null               // 'city', 'county', 'state','others'
            locationPrecision: "street"             // 'unknown', 'state_centroid', 'postal_centroid', 'street'            

            // 6 - Stats
            id: 1588848
            createdAt: "2022-08-03T01:09:18.557349Z"
            updatedAt: "2022-08-03T01:09:18.557349Z"
            lat: 38.6332
            lon: -90.2164


            // Taxonomies
            taxonomies: {open-eligibility-2022: Array(2), tcare-taxonomy-1: Array(3)}



            // NEED TO FIND OUT MORE INFO ABOUT SHOWING/HIDING THESE FIELDS

            googleTestimonials: null
            minerNotes: []                          // e.g. cannot verify website
            source: "MealsOnWheels"                 // perhaps on a future "Provider Page"
            supportedInsurance: null                // legacy field?


            // FIXED PRESET VALUES (users cannot add their own)

            availability - 'available','unavailable','wait_list','others'
            coverageGranularity - 'city', 'county', 'state','others'
            locationPrecision - 'unknown', 'state_centroid', 'postal_centroid', 'street'
        }

    */

    import { onMount } from 'svelte';
    import { SERVICE_NAME, DESCRIPTION, PHONE, FAX } from '../../common/constants.js';
    import { EMAIL, OP_HOURS, NATIONWIDE_ACCESS, WEBSITE, ID } from '../../common/constants.js';

    // TCARE components
    import DataTextField from '../data-fields/DataTextField.svelte';
    import DataEmailField from '../data-fields/DataEmailField.svelte';
    import DataWebField from '../data-fields/DataWebField.svelte';
    import DataSelectField from '../data-fields/DataSelectField.svelte';
    import FieldGroupExpandBar from './FieldGroupExpandBar.svelte';

    const GROUP_TITLE = 'Service Information';

    export let store;                   // store is a Service store - not just data!
    export let leftService;             // only used for diffs - not passed to DataFields
    export let rightService;            // only used for diffs - not passed to DataFields
    export let onCopyValue;             //
    export let isEditable;              //
    export let isOpen;                  // initial opened state
    export let showDiffs;               // bypass the strike-through and highlighting

    // $: apiData = $store.apiData;
    $: isExpanded = isOpen;

    onMount(() => {
    })

    const toggleIsExpanded = () => {
        isExpanded = !isExpanded;
    }


    // TODO: could move these to common area
    // could calc inside field but then would need to pass in L and R
    const isFieldDiff = (propName) => {
        if (!leftService) return false;
        if (!rightService) return false;
        return leftService[propName] !== rightService[propName];
    }

    /*
    const isArrayFieldDiff = (propName) => {
        if (!leftService) return false;
        if (!rightService) return false;
        if (leftService.lenth === 0 && rightService.lenth === 0) return true;
        return !shallowArraysEqual(leftService[propName], rightService[propName]);
    }

    const getDiffCount = () => {
        let diffs = 0;
        for (const field of FIELDS) {
            if (isFieldDiff(field)) diffs++;
        }
        return diffs;
    }
    */

</script>

<style>

    .fields-area-wrapper {
        overflow: hidden;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="field-group">
    
    <FieldGroupExpandBar title={GROUP_TITLE} {isExpanded} {toggleIsExpanded} />

    <div class="fields-area-wrapper">
        {#if $store.apiData && isExpanded}
            <!-- in:fly="{{ y: -200, duration: 250 }}" out:fly="{{ y: -200, duration: 250 }}"> -->
            <div class="fields-area" >

                <!-- left and right blocks in a fluid row -->
                <div class="flex-row ai-start fluid">
                    <div class="flex-block w-49">
                        <DataTextField
                            bind:value={$store.apiData[SERVICE_NAME]}
                            propName={SERVICE_NAME}
                            label={'Service Name'}
                            isEditable={isEditable}
                            isOrigDiff={isFieldDiff(SERVICE_NAME)}
                            isNewDiff={isFieldDiff(SERVICE_NAME)}
                            onCopyValue={onCopyValue}
                            tooltip={$store.apiData[SERVICE_NAME]}
                            {showDiffs}
                        />
                        
                        <DataTextField
                            bind:value={$store.apiData[DESCRIPTION]}
                            propName={DESCRIPTION}
                            label={'Description'}
                            isEditable={isEditable}
                            isOrigDiff={isFieldDiff(DESCRIPTION)}
                            isNewDiff={isFieldDiff(DESCRIPTION)}
                            onCopyValue={onCopyValue}
                            tooltip={$store.apiData[DESCRIPTION]}
                            {showDiffs}
                        />

                        <DataTextField
                            bind:value={$store.apiData[PHONE]}
                            propName={PHONE}
                            label={'Phone'}
                            isEditable={isEditable}
                            isOrigDiff={isFieldDiff(PHONE)}
                            isNewDiff={isFieldDiff(PHONE)}
                            onCopyValue={onCopyValue}
                            tooltip={''}
                            {showDiffs}
                        />

                        <DataTextField
                            bind:value={$store.apiData[FAX]}
                            propName={FAX}
                            label={'Fax'}
                            isEditable={isEditable}
                            isOrigDiff={isFieldDiff(FAX)}
                            isNewDiff={isFieldDiff(FAX)}
                            onCopyValue={onCopyValue}
                            tooltip={''}
                            {showDiffs}
                        />
                    </div>  <!-- flex-block -->

                    <div class="flex-block w-49">
                        <DataEmailField
                            bind:value={$store.apiData[EMAIL]}
                            propName={EMAIL}
                            label={'Email'}
                            isEditable={isEditable}
                            isOrigDiff={isFieldDiff(EMAIL)}
                            isNewDiff={isFieldDiff(EMAIL)}
                            onCopyValue={onCopyValue}
                            tooltip={''}
                            {showDiffs}
                        />
                        
                        <DataTextField
                            bind:value={$store.apiData[OP_HOURS]}
                            propName={OP_HOURS}
                            label={'Hours'}
                            isEditable={isEditable}
                            isOrigDiff={isFieldDiff(OP_HOURS)}
                            isNewDiff={isFieldDiff(OP_HOURS)}
                            onCopyValue={onCopyValue}
                            tooltip={$store.apiData[OP_HOURS]}
                            {showDiffs}
                        />

                        <DataWebField
                            bind:value={$store.apiData[WEBSITE]}
                            propName={WEBSITE}
                            label={'Web'}
                            isEditable={isEditable}
                            isOrigDiff={isFieldDiff(WEBSITE)}
                            isNewDiff={isFieldDiff(WEBSITE)}
                            onCopyValue={onCopyValue}
                            tooltip={$store.apiData[WEBSITE]}
                            {showDiffs}
                        />  
                        
                        <!--
                        <DataSelectField
                            bind:value={$store.apiData[NATIONWIDE_ACCESS]}
                            propName={NATIONWIDE_ACCESS}
                            label={'Nationwide Access'}
                            isEditable={isEditable}
                            isOrigDiff={isFieldDiff(NATIONWIDE_ACCESS)}
                            isNewDiff={isFieldDiff(NATIONWIDE_ACCESS)}
                            onCopyValue={onCopyValue}
                            tooltip={''}
                            {showDiffs}
                        />
                        -->

                    </div>  <!-- flex-block -->
                </div>  <!-- flex-row -->
            </div>  <!-- fields-area -->
        {/if}
    </div>  <!-- fields-area-wrapper -->
</div>

